// export const SERVICE_URL            = 'http://localhost:9100';
// export const FUNBOX_SERVICE_URL     = 'http://localhost:8555';
// export const WS_SERVICE_URL         = 'ws://localhost:7666';
// export const CLIENT_URL             = 'http://localhost:7101';
// export const MONITOR_URL_TEMPLATE   = 'http://localhost:7100/monitor/{roomId}';
export const SERVICE_URL = 'https://api.funboxmusic.com/rest/';
export const FUNBOX_SERVICE_URL = 'https://api.gestion.funboxmusic.com/';
export const WS_SERVICE_URL = 'wss://ws.funboxmusic.com/ws';
export const CLIENT_URL = 'https://binfun.app';
export const MONITOR_URL_TEMPLATE = 'https://animator.binfun.app/monitor/{roomId}';
// export const SERVICE_URL              = 'https://api.funboxmusic.com/rest/';
// export const FUNBOX_SERVICE_URL       = 'https://api.gestion.funboxmusic.com/';
// export const WS_SERVICE_URL           = 'wss://ws.funboxmusic.com/ws';
// export const CLIENT_URL               = 'https://binfun.funboxmusic.com';
// export const MONITOR_URL_TEMPLATE     = 'https://backend.funboxmusic.com/monitor/{roomId}';
export const APP_ID = '9dcbcab5-c313-432f-b4d2-e0c52e353247';
export const SUPERADMIN_ID = 1;
export const MANAGER_ID = 2;
export const userTypes = [
    {
        id: SUPERADMIN_ID,
        name: 'Superadmin'
    },
    {
        id: MANAGER_ID,
        name: 'Animador'
    }
];
